export default {
  locations: {
    syowa: {
      is2D: true,
      file: 'asset/map/syowa_map.jpg',
      rotateOffset: 0,
      imageSize: [ 1000, 687 ],
    },
    syowaZoom: {
      is2D: true,
      floors: [
        { label: '西部地区',
          id: 'west',
//          file: './data/antarctic360/assets/map/2abb7e16-0966-11ec-8539-06d61ac6b8d1-1/plane',
          file: './asset/map/昭和基地西部地区.png',
          rotateOffset: 0,
//          imageSize: [ 1000, 918 ],
          imageSize: [ 1174, 1076 ],
        },
        { label: '東部地区',
          id: 'east',
//          file: './data/antarctic360/assets/map/36ed6352-0966-11ec-8e14-063b2b63adb9-1/plane',
          file: './asset/map/昭和基地東部地区.png',
          rotateOffset: 0,
          imageSize: [ 1122, 1016 ],
        },
        { label: '管理棟1F',
          id: '管理棟1F',
          file: './asset/map/管理棟.png',
          imageSize: [ 1350, 1030 ],
          rotateOffset: 0,
        },
        { label: '管理棟2F',
          id: '管理棟2F',
          file: './asset/map/管理棟.png',
          imageSize: [ 1350, 1030 ],
          rotateOffset: 0,
        },
        { label: '管理棟3F',
          id: '管理棟3F',
          file: './asset/map/管理棟.png',
          imageSize: [ 1350, 1030 ],
          rotateOffset: 0,
        },
        { label: '通路棟・防火区画',
          id: '通路棟・防火区画',
          file: './asset/map/通路棟・防火区画.png',
          imageSize: [ 1292, 632 ],
          rotateOffset: 0,
        },
        { label: '発電棟',
          id: '発電棟',
          file: './asset/map/発電棟.png',
          imageSize: [ 1250, 880 ],
          rotateOffset: 0,
        },
        { label: '倉庫棟',
          id: '倉庫棟',
          file: './asset/map/倉庫棟.png',
          imageSize: [ 1100, 820 ],
          rotateOffset: 0,
        },
        { label: '基本観測棟1F',
          id: '基本観測棟1F',
          file: './asset/map/基本観測棟.png',
          imageSize: [ 840, 920 ],
          rotateOffset: 0,
        },
        { label: '基本観測棟2F',
          id: '基本観測棟2F',
          file: './asset/map/基本観測棟.png',
          imageSize: [ 840, 920 ],
          rotateOffset: 0,
        },

        { label: '観測棟',
          id: '観測棟',
//          file: './data/antarctic360/assets/map/66b47d68-0967-11ec-aa5b-0ac78d0bad4f-1/plane',
          file: './asset/map/観測棟.png',
          rotateOffset: 0,
          imageSize: [ 1160, 750 ],
        },
        { label: '情報処理棟',
          id: '情報処理棟',
//          file: './data/antarctic360/assets/map/5c9b5e1a-0966-11ec-8539-06d61ac6b8d1-1/plane',
          file: './asset/map/情報処理棟.png',
          rotateOffset: 0,
          imageSize: [ 1060, 610 ],
        },
        { label: '光学観測棟',
          id: '光学観測棟',
//          file: './data/antarctic360/assets/map/83a0a780-0967-11ec-8579-063b2b63adb9-1/plane',
          file: './asset/map/光学観測棟.png',
          rotateOffset: 0,
          imageSize: [ 1100, 650 ],
        },
        { label: '地学棟',
          id: '地学棟',
          file: './asset/map/地学棟.png',
          imageSize: [ 920, 620 ],
          rotateOffset: 0,
        },
        { label: '旧放球棟',
          id: '旧放球棟',
          file: './asset/map/旧放球棟.png',
          imageSize: [ 690, 600 ],
          rotateOffset: 0,
        },
        { label: '焼却炉棟',
          id: '焼却炉棟',
          file: './asset/map/焼却炉棟.png',
          imageSize: [ 750, 600 ],
          rotateOffset: 0,
        },
        { label: '重量計室',
          id: '重量計室',
          file: './asset/map/重量計室.png',
          imageSize: [ 800, 630 ],
          rotateOffset: 0,
        },
        { label: '電離層棟',
          id: '電離層棟',
          file: './asset/map/電離層棟.png',
          imageSize: [ 930, 730 ],
          rotateOffset: 0,
        },
        { label: '衛星受信棟',
          id: '衛星受信棟',
          file: './asset/map/衛星受信棟.png',
          imageSize: [ 990, 820 ],
          rotateOffset: 0,
        },
        { label: '自然エネルギー棟',
          id: '自然エネルギー棟',
          file: './asset/map/自然エネルギー棟.png',
          imageSize: [ 1250, 820 ],
          rotateOffset: 0,
        },
        { label: '多目的大型アンテナレドーム',
          id: '多目的大型アンテナレドーム',
//          file: './data/antarctic360/assets/map/f9320994-0967-11ec-aa5b-0ac78d0bad4f-1/plane',
          file: './asset/map/多目的アンテナレドーム.png',
          rotateOffset: 0,
          imageSize: [ 1440, 970 ],
        },
        { label: 'インテルサットレドーム',
          id: 'インテルサットレドーム',
          file: './asset/map/インテルサットレドーム.png',
          imageSize: [ 1112, 856 ],
          rotateOffset: 0,
        },
        { label: '清浄大気観測小屋',
          id: '清浄大気観測小屋',
          file: './asset/map/清浄大気観測小屋.png',
          imageSize: [ 1130, 810 ],
          rotateOffset: 0,
        },
        { label: '地震計室',
          id: '地震計室',
          file: './asset/map/地震計室.png',
          imageSize: [ 970, 650 ],
          rotateOffset: 0,
        },
        { label: '重力計室',
          id: '重力計室',
          file: './asset/map/重力計室.png',
          imageSize: [ 800, 630 ],
          rotateOffset: 0,
        },
      ],
    },
    shirase: {
      is2D: true,
      file: 'asset/shirase_map.jpg',
      rotateOffset: 0,
      imageSize: [ 1000, 564 ],
    },
  },
  views: {
    syowa: [
      'syowaZoom',
      'syowa',
    ],
    shirase: [
      'shirase',
    ],
  },
  locationNames: {
    shirase: 'しらせ',
    syowa: '昭和基地',
  },
}

